<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <section class="page-tit__wrap">
      <h1 class="page-tit__sub">KNVD 소개</h1>
      <p class="page-tit">KISA 취약점 처리 절차</p>
    </section>
    <section class="section-pt">
      <!-- 입수단계 -->
      <article class="description">
        <h2 class="section-title">입수단계</h2>
        <p class="description__content">
          내부 입수, 신고포상제(KrCERT), 외부신고(118), 유관기관 공유 등을 통해
          취약점 접수
        </p>
      </article>
      <!-- 분석단계 -->
      <article class="description">
        <h2 class="section-title">분석단계</h2>
        <p class="description__content">
          신고자의 신고 내용(보고서, 이메일 등)을 바탕으로 취약점
          분석(신규취약점 여부, 취약점 파급도 등)
        </p>
      </article>
      <!-- 대응단계 -->
      <article class="description">
        <h2 class="section-title">대응단계</h2>
        <p class="description__content">
          제조사에 취약점 조치를 요청하고, 보안 패치 개발 및 검증<br />해외
          제품의 취약점인 경우 해외CERT 또는 해당 제조사에 취약점 관련 정보 전달
        </p>
      </article>
      <!-- 공유단계 -->
      <article class="description">
        <h2 class="section-title">공유단계</h2>
        <p class="description__content">
          국내 파급력이 높다고 판단되는 취약점의 경우 유관기관 정보공유 및
          대국민 보안공지<br />
          (정보공유) 취약한 제품 사용하는 기관 중 금융, 공공, 교육기관이
          존재하는 경우, 취약점 관련 정보를 전달<br />
          (보안공지) 피해 규모 및 위험도를 고려하여 일반 사용자가 다수 포함되어
          있는 경우 대국민 긴급 보안공지<br />
          ※ 언론보도, 취약점 포털 및 보호나라 홈페이지 보안공지 게시 등 대국민
          안내.
        </p>
      </article>
      <!-- 입수단계&분석단계&대응단계 이미지 -->
      <figure class="diagram-area" aria-hidden="true">
        <picture class="light-only">
          <!-- 모바일용 -->
          <source
            srcset="@/assets/img/intro/img_process_m.png"
            media="(max-width: 767.9px)"
          />
          <!-- 태블릿용 -->
          <source
            srcset="@/assets/img/intro/img_process_tb.png"
            media="(max-width: 1399.9px)"
          />
          <!-- PC용 -->
          <img src="@/assets/img/intro/img_process.png" alt="" />
        </picture>
        <picture class="dark-only">
          <!-- 모바일용 -->
          <source
            srcset="@/assets/img/intro/img_process_m_dark.png"
            media="(max-width: 767.9px)"
          />
          <!-- 태블릿용 -->
          <source
            srcset="@/assets/img/intro/img_process_tb_dark.png"
            media="(max-width: 1399.9px)"
          />
          <!-- PC용 -->
          <img src="@/assets/img/intro/img_process_dark.png" alt="" />
        </picture>
      </figure>
    </section>
  </div>
</template>
